import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import { Fade, Zoom } from '@mui/material';
import LoadingScreen from '../common/Loading/loading';
import backgroundImage from '../assets/linkwaybg5.png';

const ComingSoonPage = () => {
  return (
    <Fade in timeout={500}>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          textAlign: 'center',
          color: 'white',
          padding: 2,
        }}
      >
        <LoadingScreen />
        <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold', color: '#333', mt: 35 }}>
          Linkway: A Way to Linking
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#332' }}>
          We are working hard to bring Linkway to you. Stay tuned!
        </Typography>
      </Box>
    </Fade>
  );
};

export default ComingSoonPage;
